import { render, staticRenderFns } from "./ItemTDCHD.vue?vue&type=template&id=0aa30ca9&scoped=true"
import script from "./ItemTDCHD.vue?vue&type=script&lang=js"
export * from "./ItemTDCHD.vue?vue&type=script&lang=js"
import style0 from "./ItemTDCHD.vue?vue&type=style&index=0&id=0aa30ca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa30ca9",
  null
  
)

export default component.exports